import { Component, inject, viewChild } from '@angular/core';

import { SelectedItemCounterDirective } from './selected-item-counter.directive';
import { TagComponent } from '../../../../../common/tag/tag.component';

@Component({
  selector: 'rt-select-selected-item-counter',
  imports: [SelectedItemCounterDirective, TagComponent],
  template: `
    <ng-container *rtSelectSelectedItemCounter="let dir; let hiddenCount = hiddenCount">
      <rt-tag [name]="'+' + hiddenCount"></rt-tag>
    </ng-container>
  `,
  providers: [
    {
      provide: SelectedItemCounterDirective,
      useFactory: () => inject(SelectedItemCounterComponent).directive(),
    },
  ],
})
export class SelectedItemCounterComponent {
  public directive = viewChild.required(SelectedItemCounterDirective);
}
